import { createPlugin } from '@backstage/core-plugin-api';
import { createSearchResultListItemExtension } from '@backstage/plugin-search-react';

export const searchMdsolPlugin = createPlugin({
  id: 'search-mdsol',
});

export const CatalogSearchResultListItem = searchMdsolPlugin.provide(
  createSearchResultListItemExtension({
    name: 'CatalogSearchResultListItem',
    component: () =>
      import('./components').then(m => m.CatalogSearchResultListItem),
    predicate: result => result.type === 'software-catalog',
  }),
);
